const nail1 = require("./nail1.jpg");
const nail2 = require("./nail2.jpg");
const nail3 = require("./nail3.jpg");
const nail4 = require("./nail4.jpg");
const nail5 = require("./nail5.jpg");
const nail6 = require("./nail6.jpg");
const nail7 = require("./nail7.jpg");
const nail8 = require("./nail8.jpg");
const nail9 = require("./nail9.jpg");
const nail10 = require("./nail10.jpg");
const nail11 = require("./nail11.jpg");
const nail12 = require("./nail12.jpg");
const nail13 = require("./nail13.jpg");
const nail14 = require("./nail14.jpg");
const nail15 = require("./nail15.jpg");
const nail16 = require("./nail16.jpg");
const nail17 = require("./nail17.jpg");
const nail18 = require("./nail18.jpg");
const nail19 = require("./nail19.jpg");
const nail20 = require("./nail20.jpg");
const nail21 = require("./nail21.jpg");
const nail22 = require("./nail22.jpg");

export const images = {
  pricing: require("./pricing.jpg"),

  nail1,
  nail2,
  nail3,
  nail4,
  nail5,
  nail6,
  nail7,
  nail8,
  nail9,
  nail10,
  nail11,
  nail12,
  nail13,
  nail14,
  nail15,
  nail16,
  nail17,
  nail18,
  nail19,
  nail20,
  nail21,
  nail22,

  nail01: nail1,
  nail02: nail2,
  nail03: nail3,
  nail04: nail4,
  nail05: nail5,
  nail06: nail6,
  nail07: nail7,
  nail08: nail8,
  nail09: nail9,

  banner02: nail20,
  banner03: nail19,
  popup: nail22,

  blackPinkPolkaDotNails: nail1,
  blackPolkaDotFrenchNails: nail2,
  blushPearlAlmondNails: nail3,
  burgundyCreamPolkaDotNailsWide: nail4,
  burgundyCreamPolkaDotNails: nail5,
  burgundyPolkaDotFrenchNails: nail6,
  classicWhiteFrenchManicure: nail7,
  floralPolkaDotFrenchNails: nail8,
  goldOutlineFrenchNails: nail9,
  hotPinkPolkaDotSquareNails: nail10,
  pastelBunnyNailArt: nail11,
  pearlChromeAlmondNails: nail12,
  pinkFloralGelNails: nail13,
  redBowAccentNails: nail14,
  redHeartLipNailArt: nail15,
  roseGoldChromeStilettoNails: nail16,
  softPinkDotAlmondNails: nail17,
  whiteDotLinePinkNails: nail18,
};
